export default __webpack_public_path__ + "static/media/orbit.4d458310.svg";